import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  TextField,
  InputAdornment,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { auth } from '../services/firebase';


import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CustomButton from "../components/CustomButton";
import { signOut, onAuthStateChanged } from "firebase/auth";
import TopBar from "../components/TopBar";

const ModifyDetails = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [username, setUsername] = useState("");
  const [paypalHandle, setPaypalHandle] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleCreateAccount = () => {
    if (username && password) {
      navigate("/Login");
    }
  };

  const onLogout = () => {
    const unsubscribe = signOut(auth)
    .then(() => {
      navigate('/')
    })

    return () => unsubscribe()
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
      } else {
        setUser(currentUser)
      }
    })

    return () => unsubscribe()
  }, [user])

  const clearInput = (inputField) => {
    switch (inputField) {
      case "username":
        setUsername("");
        break;
      case "paypalHandle":
        setPaypalHandle("");
        break;
      case "email":
        setEmail("");
        break;
      case "password":
        setPassword("");
        break;
      default:
        break;
    }
  };
  return (
    <Box className="max_container" sx = {{ marginTop: 8 }}>
      <TopBar/>
      <Stack spacing={2} className="mt-12 mb-4">
        {/* usename textfield  */}
        <TextField
          id="input-with-icon-textfield"
          label="Username"
          placeholder="djjosu"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <DriveFileRenameOutlineOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("username")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
        {/* paypal acount input  */}
        <TextField
          id="input-with-icon-textfield"
          label="Paypal handle"
          placeholder="josuguti"
          fullWidth
          type="text"
          value={paypalHandle}
          onChange={(e) => setPaypalHandle(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PaymentOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("paypalHandle")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
        {/* email  input*/}
        <TextField
          id="input-with-icon-textfield"
          label="Email"
          placeholder="djemail@gmail.com"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("email")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />

        {/* Password input  */}
        <TextField
          id="input-with-icon-textfield"
          label="Password"
          placeholder="**********"
          type="password"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("password")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </Stack>
      {/* Buttons */}
      <Stack spacing={2} className="mt-6 px-12">
        <CustomButton
          myFunction={handleCreateAccount}
          text={"Update"}
        />
        <CustomButton
          myFunction={onLogout}
          text={"Log Out"}
        />
      </Stack>
    </Box>
  );
};

export default ModifyDetails;
